export default __webpack_public_path__ + "static/media/TVinsure-Contact-Me.8f7db9b8.png";